
    <div [class.active]="active" class="item">
      <ng-content></ng-content>
    </div>
  